import { useEffect } from "react";

const STORAGE_KEY = "myt_skin";
const VALID_SKINS = ["02"];
const DEFAULT_SKIN = "02";

function readInitialSkin() {
  if (typeof window === "undefined") return DEFAULT_SKIN;
  const params = new URLSearchParams(window.location.search);
  const fromUrl = params.get("skin");
  if (fromUrl && VALID_SKINS.includes(fromUrl)) {
    try {
      window.localStorage.setItem(STORAGE_KEY, fromUrl);
    } catch (_) {}
    return fromUrl;
  }
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && VALID_SKINS.includes(stored)) return stored;
  } catch (_) {}
  return DEFAULT_SKIN;
}

// Apply the skin synchronously on module load so the first paint already has
// the correct tokens — avoids a flash of the default palette.
if (typeof document !== "undefined") {
  document.documentElement.dataset.skin = readInitialSkin();
}

export function useSkin() {
  useEffect(() => {
    document.documentElement.dataset.skin = readInitialSkin();
  }, []);
  return document.documentElement.dataset.skin || DEFAULT_SKIN;
}
